import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/gateway';

function baseApi() {

    function getInstanceList(instanceName) {
        return Post(baseUrl + `/discovery/instance/list/${instanceName}`, {});
    }

    return {
        getInstanceList
    };
}

export const nacosApi = baseApi();